module.exports = __webpack_public_path__ + "img/card-t4.06a35d12.png";